import React, { Component } from "react";
import SectionFooter from "./sectionfooter";

class Jugendarbeit extends Component {
  render() {
    return (
      <section id="jugend">
        <h1>Jugendarbeit im Tambour-Korps</h1>
        <div className="no-bottom-margin">
          Die Ausbildung und Förderung der Jugend ist ein wichtiger, ja wenn
          nicht sogar der wichtigste Teil der Vereinsarbeit.<br />
          Wie auch unsere Chronik zeigt, verstanden es immer wieder aktive
          Spieler Jugendliche vom "mitmachen" und vor allem mit Musizieren in
          unserem Verein zu begeistern.<br />
          Vor dem ersten öffentlichen Auftritt steht jedoch erst eine mehr oder
          weniger lange Zeit des Probens. Alle Märsche wurden auswendig gelernt.
          Das bedeutet sehr viel Einsatz und Üben. Es dauert je nach Talent eine
          gewisse Zeit bis alle den "neuen Marsch" beherrschen und gemeinsam
          spielen können. Nicht jeder schafft das Ziel. Einige "unterliegen
          ihrem Fleiß" und geben bereits in den ersten Monaten auf.
          Glücklicherweise ist dies der kleinere Prozentsatz, denn diejenigen,
          welche erst einmal Fuß im Korps gefasst haben und die ersten Monate
          absolviert haben, erkennen bald, dass alles zu lernen ist, wenn
          Einsatzwille und Bereitschaft vorhanden sind. So dürfen wir mit dem
          jugendlichen Nachwuchs in unserem Tambour-Korps recht zufrieden sein,
          denn echte Begeisterung und voller Einsatz sind für die Proben der
          schönste Lohn.<br />Auch die gemeinsame Privatgestaltung im Verein und
          besonders in der Gruppe der jugendlichen Spieler eine starke
          Bedeutung.<br />
          <br />
          <br />
          <br />
          Gemeinsame Veranstaltungen wie unser:<br />
          <br />
          Traditionelles<br />
          <ul>
            <li>
              Wald- und Wiesenfest (Der jährliche Abschluss mit vereinsinternem
              Vogelschießen)
            </li>
            <li>Familienwandertag an Christi Himmelfahrt und</li>
            <li>Weihnachtsfeier</li>
            <li>
              Jährliche Jugendausflüge, wie z. B. nach Movie World in Bottrop,
              Phantasialand in Brühl, Odysseum in Köln, Zoo in Hannover oder der
              Heide Park.
            </li>
          </ul>
          <br />
          Gemeinsame Ausflüge aller Aktiven:<br />
          <ul>
            <li>
              Mehrtägige Fahrt zum Musikerfestival nach San Remo in Italien.
            </li>
            <li>Fahrten nach Kastella in Kroatien</li>
            <li>Fahrt nach Prag</li>
            <li>Besuch der Weihnachtsmärkte in Trier und Monschau</li>
            <li>Ausflüge zu den Weinfesten an Rhein, Ahr und Mosel</li>
          </ul>
          <br />
          Diese Ausflüge und Veranstaltungen festigen die Freundschaften
          untereinander und schaffen neuen Einsatz für die jährliche Auftritte
          an Karneval, Familien- und Schützenfesten.<br />
        </div>
        <SectionFooter />
      </section>
    );
  }
}

export default Jugendarbeit;



// WEBPACK FOOTER //
// ./src/components/jugendarbeit.js